import React from 'react';
import { SectionInstance } from '../types';
import { sfCtaText, sfCtaUrl, sfLogoText } from './sectionHelpers';

interface Props {
  section: SectionInstance;
  onControlChange?: (key: string, value: any) => void;
}

const NavStandard: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  // Python: logo_text → brand_name → logo_alt fallback chain
  const logoText = sfLogoText(c, 'Logo');
  // Support both `links` and `nav_links`
  const links = (c.links || c.nav_links || []) as Array<{ label: string; url: string }>;
  const isSticky = c.sticky === true || c.sticky === 'true';

  const navStyle: React.CSSProperties = {
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0,0,0,0.08)',
    background: c.background_color || '#fff',
    ...(isSticky ? { position: 'sticky', top: 0, zIndex: 100 } : {}),
  };

  return (
    <nav className="sb-render sb-render-nav" style={navStyle}>
      <div style={{ fontWeight: 700, fontSize: '1.25rem', color: 'var(--brand-primary, #1a365d)' }}>
        {c.logo_url ? (
          <img src={c.logo_url} alt={logoText} style={{ height: 40 }} />
        ) : (
          // Show a branded lettermark circle if no logo image
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'var(--brand-primary, #1a365d)',
              color: '#fff', display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontWeight: 800, fontSize: '1rem',
              flexShrink: 0,
            }}>
              {logoText.charAt(0).toUpperCase()}
            </div>
            <span>{logoText}</span>
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
        {links.map((link, i) => (
          <a key={i} href={link.url || '#'} style={{ color: '#64748b', textDecoration: 'none', fontWeight: 500 }}>
            {link.label}
          </a>
        ))}
        {sfCtaText(c) && (
          <a href={sfCtaUrl(c)} style={{
            padding: '10px 24px',
            borderRadius: 'var(--brand-btn-radius, 6px)',
            background: 'var(--brand-primary, #1a365d)',
            color: '#fff',
            fontWeight: 600,
            textDecoration: 'none',
          }}>
            {sfCtaText(c)}
          </a>
        )}
      </div>
    </nav>
  );
};

export default NavStandard;
